export const EVIDENCE_STATUS_INIT = 'init';
export const EVIDENCE_STATUS_SELECTED = 'selected';
export const EVIDENCE_STATUS_EXCLUDED = 'excluded';
